/**
 * Enumeration class for Language
 */
export enum Language {
    
        "português"
        ,
    
        "inglês"
        
    
}
